import React from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import usePermissions from "../../redux/selectors/usePermissions";
import ValidateOrderDetails from "./ValidateOrderDetails";

const ValidateOrderDetailsContainer = ({
  order,
  updateOrder,
  isUpdatingOrder,
  isLoading
}) => {
  const {
    allowAdminConsole,
    validate,
    allowValidate,
    isEmployeeManager,
    allowValidateRole
  } = usePermissions();
  const showFinalReviewBtn =
    allowAdminConsole ||
    ((validate || allowValidate) && (isEmployeeManager || allowValidateRole));

  return (
    <>
      {(isLoading && !isUpdatingOrder) || !order ? (
        <LoadingSpinner />
      ) : (
        <ValidateOrderDetails
          order={order}
          updateOrder={updateOrder}
          isUpdating={isUpdatingOrder}
          showFinalReviewBtn={showFinalReviewBtn}
        />
      )}
    </>
  );
};

ValidateOrderDetailsContainer.propTypes = {
  order: PropTypes.object,
  updateOrder: PropTypes.func.isRequired,
  isUpdatingOrder: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default ValidateOrderDetailsContainer;
